module.exports = __webpack_public_path__ + "assets/b.575e5e78.svg";